//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomLink from '../../CustomLinks';

type LinkSectionProps = {
  isMobileView?: boolean
  //  active: boolean,
};
const LinkSection = (props: LinkSectionProps) => {
  const { t } = useTranslation();
  return (
    <div className={props.isMobileView ? 'nav-links-mobile' : 'nav-links'}>
      <CustomLink to="/" text={t('homelink')} />
      {/* <CustomLink tag="New" to="/iit_bhubaneswar" text={t('IIT Bhubaneswar')} /> */}
      <CustomLink
        tag="New"
        to="/summer_internship_logicpro"
        text={t('Summer Internships')}
      />
      <CustomLink to="/live_classes" text={t('liveClasses')} />
      <CustomLink to="/workshop" text={t('Workshop')} />
      <CustomLink to="/about" text={t('aboutlink')} />
      {/* <CustomLink to="/courses" text={t('courseslink')} /> */}
      <CustomLink to="/300" text={t('300link')} />
      {/* <CustomLink to="/careers" text={t('careerslink')} /> */}
      <CustomLink to="/contact" text={t('contactlink')} />
      <CustomLink
        isExternalLink
        text={t('blogLink')}
        to="https://medium.com/alienbrains"
      />
    </div>
  );
};

LinkSection.defaultProps = {
  isMobileView: false
};

export default LinkSection;



// WEBPACK FOOTER //
// ./src/Components/Nav/Header/LinkSection.js